import { Flex } from '@/components/ui/flex'
import { Skeleton } from '@/components/ui/skeleton'

import * as S from './keyless-access.styled'

interface KeylessTabSkeletonProps {
  rowCount?: number
}

export const KeylessTabSkeleton = ({ rowCount = 3 }: KeylessTabSkeletonProps) => (
  <S.TabContent>
    {Array.from({ length: rowCount }, (_, i) => (
      <S.FieldRow key={i}>
        <Flex gap={6} align="center">
          <Skeleton variant="text" width="12rem" height="1.4rem" />
        </Flex>
        <Skeleton variant="text" width="16rem" height="1.4rem" />
      </S.FieldRow>
    ))}
  </S.TabContent>
)
